// Per-flow KYC configuration, keyed by a kyc block's `data_type`.
//
// c2 owns the definition of each KYC flow: which SumSub verification level to
// use and the pre-verification instructions to show. The kyc block in a job
// only carries the `data_type` selector; this map resolves it to a level +
// instructions. The SumSub component sends the resolved `level` to the workshop
// token endpoint, which simply mints a token for it.
//
// This is intentionally separate from the heavier screen-capture instructions
// registry (src/data/instructions/*), which is built around video/upload flows
// and is the wrong shape for a simple title + steps.
//
// `default` reproduces the historical hardcoded copy and level verbatim, so any
// block whose `data_type` is missing or unrecognized behaves exactly as before.

const KYC_FLOWS = {
  default: {
    level: "id-and-liveness",
    title: "Before you start",
    intro:
      "It's important you complete each step, or we won't be able to process your payment! Our instructions are easy to follow.",
    steps: ["Complete the KYC process by following the instructions below"],
  },

  // Single-step liveness check only (SumSub dashboard level "liveness-only").
  "liveness-only": {
    level: "liveness-only",
    title: "Before you start",
    intro:
      "We need you to complete the KYC process below before we can process your payment. It only takes a couple of minutes.",
    steps: [
      "Complete the liveness check",
    ],
  },

  // Multi-step flow: email -> phone -> liveness (SumSub dashboard level "liveness_phone_email").
  liveness_phone_email: {
    level: "liveness_phone_email",
    title: "Before you start",
    intro:
      "We need to verify a few details before you can be paid. You'll confirm your email, then your phone number, and finally complete a quick liveness check. It only takes a couple of minutes.",
    steps: [
      "Verify your email address",
      "Verify your phone number",
      "Complete the liveness check",
    ],
  },
};

export function getKycFlow(dataType) {
  return KYC_FLOWS[dataType] || KYC_FLOWS.default;
}
